"use client"

import { SectionHeadingProps } from "./interface";
import { cn } from "@/src/utils/shadcn";

/**
 * This component renders a text section with `subtitle`, `title`,
 * and `description`. It has styling options for alignment
 * @param SectionHeadingProps
 * @returns JSX.Element
 */

export function SectionHeading({
  subtitle,
  title,
  description,
  alignment = "start",
  hasBottomSpacing = false,
  className,
  params
}: SectionHeadingProps) {
  const wrapperClasses = cn(
    alignment === "start" && "text-start",
    alignment === "center" && "text-center",
    alignment === "end" && "text-start",
    { "mb-10 md:mb-[3.75rem]": hasBottomSpacing },
    className
  );

  const lang = typeof window !== "undefined" ? window.location.pathname.split("/")[1] : "";
  const isArabic = lang === "ar";

  return (
    <div className={wrapperClasses}>
      {subtitle && (
        <span
          className={
            `mb-[.625rem] block font-secondary text-base	 font-bold uppercase leading-[1.5] tracking-widest text-primary md:text-md
            ${isArabic? 'text-lg': ''}`
          }
        >
          {subtitle}
        </span>
      )}
      <h2 className={`font-secondary text-xl font-bold leading-[1.25] text-accent-900 dark:text-white ${isArabic ? "md:text-xl font-bold" : "md:text-2xl"} `}>
        <span className=" ">{title && title?.split(" ")[0]}</span>
        {` ${title && title?.split(" ")?.slice(1).join(" ")}`}
      </h2>
      {description && (
        <p className={"mt-5 whitespace-pre-line"}>{description}</p>
      )}
    </div>
  );
}
